import service from './baseService';
import { getModelTypeIDAndEntityID } from '../config';

export const listVehicleSegments = (relatedVehicleAssignment) => {
    let params = { ...getModelTypeIDAndEntityID() };
    if (relatedVehicleAssignment) params.relatedVehicleAssignment = relatedVehicleAssignment;
    return service.get(`/driver-vehicle-segments`, { params });
};
